class ParagarhpAccordion {
    constructor(accordion) {
        this.accordion = accordion
        this.accordionID = accordion.dataset.id
        this.button = document.querySelector('[data-id="' + this.accordionID + '"] .o-accordion-paragraph__button')

        this.button.addEventListener('click', function () {
            this.accordion.classList.toggle('is-active')
        }.bind(this))
    }
}

window.addEventListener('DOMContentLoaded', function () {
    const paragrapgAccordions = this.document.querySelectorAll('.o-accordion-paragraph')

    paragrapgAccordions.forEach(paragrapgAccordion => {
        new ParagarhpAccordion(paragrapgAccordion)
    });
})
